import { Autocomplete, Box, TextField } from "@mui/material";
import { MarkJobReadyForm } from "../MarkJobReadyForm";
import { LoadingComponent } from "../../helpers";
import { useMarkJobReadyPageViewModel } from "./MarkJobReadyPage.vm";
import { MarkJobReadyPageProps } from "./MarkJobReadyPage.types";
import "./MarkJobReadyPage.css";

export function MarkJobReadyPage(props: MarkJobReadyPageProps) {
	const vm = useMarkJobReadyPageViewModel(props);

	return (
		<Box className="mark-job-ready-page">
			<div id="choose-your-company">
				{vm.growers.length > 0 && (
					<Autocomplete
						fullWidth
						className="proacrica-select-dropdown"
						multiple
						options={vm.growers}
						value={vm.selectedGrowers}
						getOptionKey={(option) => option.id}
						getOptionLabel={(option) => option.name || ""}
						onChange={(event, value) => vm.onGrowersChanged(value)}
						renderInput={(params) => <TextField {...params} label="Select Growers" variant="outlined" />}
					/>
				)}
				{vm.isLoading ? (
					<Box className="loading-container">
						<LoadingComponent />
					</Box>
				) : vm.isReadyToShowForm() && vm.hasJobs() ? (
					<MarkJobReadyForm
						key={vm.selectedGrowers.map((g) => g.id).join(",")}
						initialSelectedJobs={vm.initialSelectedJobs}
						jobs={vm.jobs}
						onSubmit={vm.markJobsReady}
						onCancel={() => {}}
						onSelectionChange={vm.onSelectionChange}
					/>
				) : vm.isReadyToShowForm() && !vm.hasJobs() ? (
					<Box className="no-jobs-message">No jobs found</Box>
				) : null}
			</div>
		</Box>
	);
}
